import { v2Request } from './client';

export async function getGenericLanding() {
  return v2Request('/api/landing');
}

export async function getCustomerLanding({ mobile }) {
  return v2Request(`/api/landing/${mobile}`);
}

/** Nearest store for GPS coords — POST /api/store-selection/nearest */
export async function findNearestStoreByCoords({ lat, lng }) {
  const body = await v2Request('/api/store-selection/nearest', {
    method: 'POST',
    body: { deliveryLat: lat, deliveryLng: lng },
  });
  return body.data;
}
